import chat from '../../images/slider/chat.svg'
import document2 from '../../images/slider/document2.svg'
import search2 from '../../images/slider/search2.svg'
import search from '../../images/slider/search.svg'
import moniter from '../../images/slider/moniter.svg'
import setting from '../../images/slider/setting.svg'
import lock from '../../images/slider/lock.svg'
import defense from '../../images/slider/defense.svg'
import message from '../../images/slider/message.svg'

const data = [[
  {
    img:moniter,
    title:'Initiate chat<br/>anywhere anytime',
    sub:"Virtualizing messaging across business applications and systems that allow users to communicate from anywhere at anytime"
  },    
  {
    img:setting,
    title:"Manage chat by<br/>content, user or systems",
    sub:"Managing message threads by documents, users/groups or systems that streamline communication"
  },
  {
    img:search,
    title:"Experience user-friendly<br/>interface",
    sub:"Providing easy, intuitive and straightforward user interfaces that enhance usability and productivity"
  }],
  [
    {
      img:chat,
      title:"Communicate<br/>on the content",
      sub:"Automatically inviting users with permissions to the message threads when comments are added to the document"
    },    
    {
      img:document2,
      title:"Get rid of<br/>ROT issues",
      sub:"Eliminating the process of sharing multiple versions and minimizing redundant, obsolete and trivial data issues"
    },
    {
      img:search2,
      title:"Search message<br/>and content",
      sub:"Allowing users to search messages or documents from the messenger just like emails"
    }
  ],
  [
    {
      img:lock,
      title:"Share messages<br/>and files securely",
      sub:"Protecting messages and files using the highest level of security"
    },    
    {
      img:defense,
      title:"Encrypt all<br/>file types",
      sub:"Securing all kinds of file formats including Office, PDF, images and CAD drawings, etc."
    },
    {
      img:message,
      title:"One-click<br/>revoke all",
      sub:"Allowing the organization to revoke specific or all chat messages and files when required"
    }
  ]
]

export default data;